
// Used
export const CNXT_DOMAIN = 'cnxtDomain'
export const PROJECT_PROFILE = 'projectProfile'
export const OAUTH_URL = 'oauthUrl'
export const CNXT_JWT  = 'cnxtJWT'

// Questionable
export const AAD_AUTH_TOKEN = 'msAADAuthToken';
export const CNXT_REFRESH_TOKEN = 'cnxtRefreshToken'
export const CNXT_ACCESS_TOKEN = 'cnxtAccessToken'
export const TEAMS_AUTH_TOKEN = 'msTeamsAuthToken'
export const CNXT_TOKEN_EXPIRATION = 'cnxtAccessTokenExpiration'
export const PREFERRED_LOCALE = 'preferredLocale'


